module.exports = __webpack_public_path__ + "static/media/subscribed.0e19e1f0.svg";